import Footer from './components/Footer'
import Nav from './components/Nav'
import { RouterProvider } from './lib/router'
import HomePage from './pages/HomePage'

export default function App() {
  return (
    <RouterProvider>
      <div className="grain" aria-hidden="true" />
      <Nav />
      <HomePage />
      <Footer />
    </RouterProvider>
  )
}
